module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-bb-horo_dd5c0fe.png";